import { $$ } from '../lib/domUtils';

const filterInputs = $$('[data-sessions-filter]');
const sessions = $$('[data-session-type]');

const url = new URL(window.location);
const params = new URLSearchParams(url.search);
const initialFilters = params.getAll('type');

function applyFilters() {
  const appliedFilters = $$('[data-sessions-filter]:checked').map(x => x.dataset.sessionsFilter);

  sessions.forEach(session => {
    const visible =
      appliedFilters.length === 0 || appliedFilters.includes(session.dataset.sessionType);
    session.style.display = visible ? 'block' : 'none';
  });

  const urlParams = new URLSearchParams();
  appliedFilters.forEach(value => {
    urlParams.append('type', value);
  });
  window.history.replaceState(
    {},
    '',
    appliedFilters.length ? `${window.location.pathname}?${urlParams}` : window.location.pathname
  );
}

filterInputs.forEach(filter => {
  if (initialFilters.includes(filter.dataset.sessionsFilter)) {
    filter.checked = true;
  }

  filter.addEventListener('change', applyFilters);
});

applyFilters();
